import request from "@/config/utils/request";
import { addUrlPerFix } from "@/basa/utils";

// 新增接口
export function add(obj) {
  return request({
    url: `${addUrlPerFix(
      process.env.VUE_APP_BASA_URL
    )}/apis/basap/users/signup/tijiao`,
    method: "post",
    data: obj
  });
}
// 发送验证码
export function send(obj) {
  return request({
    url: `${addUrlPerFix(
      process.env.VUE_APP_BASA_URL
    )}/apis/basap/users/signup/send`,
    method: "post",
    data: obj
  });
}
// 列表接口
export function list(obj) {
  return request({
    url: `${addUrlPerFix(
      process.env.VUE_APP_BASA_URL
    )}/apis/basap/users/signup/list`,
    method: "post",
    data: obj
  });
}
// 同意/拒绝
export function updateApi(obj) {
  return request({
    url: `${addUrlPerFix(
      process.env.VUE_APP_BASA_URL
    )}/apis/basap/users/signup/update`,
    method: "post",
    data: obj
  });
}
